import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { grandviewMoConfig } from "./data";

export default function GrandviewMOPage() {
  return <CityPageTemplate config={grandviewMoConfig} />;
}